
import { useEffect } from 'react';
import { useToast } from '@/hooks/use-toast';
import { fetchAssessment } from './api';

interface UseAssessmentDataProps {
  id?: string;
  setLoading: (loading: boolean) => void;
  setAssessment: (assessment: any) => void;
  populateAssessmentData: (assessment: any) => void;
}

export function useAssessmentData({ 
  id, 
  setLoading, 
  setAssessment, 
  populateAssessmentData 
}: UseAssessmentDataProps) {
  const { toast } = useToast();

  // Fetch the assessment by ID
  useEffect(() => {
    const loadAssessment = async () => {
      if (!id) return;
      setLoading(true);
      try {
        const assessment = await fetchAssessment(id);
        if (assessment) {
          setAssessment(assessment);
          populateAssessmentData(assessment);
        }
      } catch (error) {
        toast({
          variant: "destructive",
          title: "Error",
          description: "Failed to load assessment"
        });
      } finally {
        setLoading(false);
      }
    };
    
    loadAssessment();
  }, [id]);
}
